import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 16px;

  h1 {
    margin: 0;
    font-size: 22px;
    font-weight: bolder;
  }
  h2 {
    margin: 12px 0 0 0;
    font-weight: 400;
  }
  button {
    border: none;
    background-color: transparent;
    color: black;
    font-size: 19px;
  }
`

export const OkButton = styled.button`
  position: relative;
  background: #ff6600 !important;
  color: #ffffff !important;
  padding: 0.5rem 2rem;
  border-radius: 4px;
  margin: 2rem auto !important;

  font-weight: 800;
`
